// extracted by mini-css-extract-plugin
export default {"gear":"notifications_gear__aCOzR","container":"notifications_container__1REVi","border":"notifications_border__cOi5U"};